import api from '/src/api.js';

export function loginDevice (form, options = {}) {
	return form.post('/devices', options);
}

export function linkDevice (form, options = {}) {
	return form.put('/devices', options);
}

export function unlinkDevice (deviceId, options = {}) {
	return api.delete(`/devices/${deviceId}`, options);
}

export function getDevice (options = {}) {
	return api.get('/devices/me', options);
}

export function updateDevice (form, options = {}) {
	return form.put(`/devices/${form.id}`, options);
}
